import { dispatchMerchantTelemetry } from "../../shared/telemetry.js";

export interface MerchantTelemetryEvent {
  eventName: string;
  payload: Record<string, string | number | boolean | undefined>;
}

export interface MerchantTelemetrySink {
  track(eventName: string, payload: MerchantTelemetryEvent["payload"]): void;
}

export function createBrowserTelemetrySink(): MerchantTelemetrySink {
  return {
    track(eventName, payload) {
      dispatchTelemetryEvent(eventName, payload);
    },
  };
}

function dispatchTelemetryEvent(
  eventName: string,
  payload: MerchantTelemetryEvent["payload"],
): void {
  if (typeof window === "undefined") return;

  dispatchMerchantTelemetry(eventName, payload);
}
